import React from "react";
import { useLanguage } from "../contexts/LanguageContext";

const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];
  return (
    <section
      data-testid="marquee"
      className="border-y border-brand-line/60 bg-white py-6 overflow-hidden"
      aria-hidden="true"
    >
      <div className="flex gap-12 marquee-track whitespace-nowrap will-change-transform">
        {items.map((word, i) => (
          <div
            key={i}
            className="flex items-center gap-12 text-brand-muted"
          >
            <span className="font-display text-2xl sm:text-3xl font-light tracking-tight">
              {word}
            </span>
            <span
              className="w-1.5 h-1.5 rounded-full bg-brand"
              aria-hidden
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
